import { Plugin } from '@ckeditor/ckeditor5-core';

export default class PopulateTestIds extends Plugin {
    init() {
        const editor = this.editor;
        const config = editor.config;
        const datatestids = config.get('datatestids').callback();

        editor.once(
            'ready',
            (eventInfo) => {
                const length = editor.ui.view.toolbar.items.length;

                for (let i = 0; i < length; i++) {
                    const buttonViewElem = editor.ui.view.toolbar.items.get(i);
                    const toolbarItemName = editor.config._config.toolbar.items[i];

                    const testId = datatestids[toolbarItemName];
                    if (testId) {
                        buttonViewElem.element.setAttribute('data-testid', testId);
                    }
                }
            },
            { priority: 'highest' },
        );
    }
}
